import React, { useState, useCallback, useEffect } from "react";
import {AppMenu} from "./AppMenu";


interface AboutUsProps {}

interface AboutUsState {}

const AboutUs: React.FC<AboutUsProps> = ({}) => {           
    const [pageState, setPageState] = useState<AboutUsState>(() => {});

    return(
        <>
        <AppMenu/>
        <div style={{minHeight: "300px"}}>Home</div>
        </>
    );
}

export default AboutUs; 
